export enum RestaurantUrlParams {
    CITY_SLUG = 'citySlug',
    RESTAURANT_SLUG = 'restaurantSlug',
    VISUAL_UUID = 'visual',
}

export type IRestaurantUrlParams = {
    citySlug: string
    restaurantSlug: string
    visualUuid?: string
}

export class RestaurantRoute {
    static createUrl = (params: IRestaurantUrlParams) => {
        const path = `/restaurants/${params.citySlug}/${params.restaurantSlug}`

        const searchParams = new URLSearchParams()

        if (params.visualUuid)
            searchParams.append(RestaurantUrlParams.VISUAL_UUID, params.visualUuid)

        const queryString = searchParams.toString()

        return queryString ? `${path}?${queryString}` : path
    }
}
